module.exports = __webpack_public_path__ + "img/Button_PlayForFreeEnabled.8bad63e5.png";